import { render, staticRenderFns } from "./KeycopyGallery.vue?vue&type=template&id=2665be4c&scoped=true"
import script from "./KeycopyGallery.vue?vue&type=script&lang=js"
export * from "./KeycopyGallery.vue?vue&type=script&lang=js"
import style0 from "./KeycopyGallery.vue?vue&type=style&index=0&id=2665be4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2665be4c",
  null
  
)

export default component.exports